import {
  animate,
  style,
  trigger,
  transition,
  query,
  group,
  state,
} from '@angular/animations'

export const routeAnimation = trigger('routeAnimation', [
  transition('1 => 2, 2 => 3', [
    style({ height: '!' }),
    query(':enter', style({ transform: 'translateX(100%)' }), {
      optional: true,
    }),
    query(
      ':enter, :leave',
      style({ position: 'absolute', top: 0, left: 0, right: 0 }),
      { optional: true },
    ),
    // animate the leave page away
    group([
      query(
        ':leave',
        [
          animate(
            '0.3s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(-100%)' }),
          ),
        ],
        { optional: true },
      ),
      // and now reveal the enter
      query(
        ':enter',
        animate(
          '0.3s cubic-bezier(.35,0,.25,1)',
          style({ transform: 'translateX(0)' }),
        ),
        { optional: true },
      ),
    ]),
  ]),
  transition('3 => 2, 2 => 1', [
    style({ height: '!' }),
    query(':enter', style({ transform: 'translateX(-100%)' }), {
      optional: true,
    }),
    query(
      ':enter, :leave',
      style({ position: 'absolute', top: 0, left: 0, right: 0 }),
      { optional: true },
    ),
    // animate the leave page away
    group([
      query(
        ':leave',
        [
          animate(
            '0.3s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(100%)' }),
          ),
        ],
        { optional: true },
      ),
      // and now reveal the enter
      query(
        ':enter',
        animate(
          '0.3s cubic-bezier(.35,0,.25,1)',
          style({ transform: 'translateX(0)' }),
        ),
        { optional: true },
      ),
    ]),
  ]),
])

export const fadeScaleAnimation =
  // trigger name for attaching this animation to an element using the [@triggerName] syntax
  trigger('fadeScaleAnimation', [
    // end state styles for route container (host)
    // state('*', style({
    //     // the view covers the whole screen with a semi tranparent background
    //     position: 'fixed',
    //     top: 0,
    //     left: 0,
    //     right: 0,
    //     bottom: 0,
    //     backgroundColor: 'rgba(0, 0, 0, 0.8)'
    // })),

    // route 'enter' transition
    transition(':enter', [
      // styles at start of transition
      style({
        opacity: 0,
        transform: 'scaleY(0)',
        // start with the content positioned off the right of the screen,
        // -400% is required instead of -100% because the negative position adds to the width of the element
        // right: '-400%',

        // start with background opacity set to 0 (invisible)
        // backgroundColor: 'rgba(0, 0, 0, 0)'
      }),

      // animation and styles at end of transition
      animate(
        '0.5s ease-in-out',
        style({
          opacity: 1,
          transform: 'scaleY(1)',
          // transition the right position to 0 which slides the content into view
          // right: 0,

          // transition the background opacity to 0.8 to fade it in
          // backgroundColor: 'rgba(0, 0, 0, 0.8)'
        }),
      ),
    ]),

    // route 'leave' transition
    transition(':leave', [
      style({
        opacity: 1,
        transform: 'scaleY(1)',
      }),
      // animation and styles at end of transition
      animate(
        '0.5s ease-in-out',
        style({
          opacity: 0,
          transform: 'scaleY(0)',
          // transition the right position to -400% which slides the content out of view
          // right: '-400%',

          // transition the background opacity to 0 to fade it out
          // backgroundColor: 'rgba(0, 0, 0, 0)'
        }),
      ),
    ]),
  ])

export const fadeAnimation =
  // trigger name for attaching this animation to an element using the [@triggerName] syntax
  trigger('fadeAnimation', [
    // route 'enter' transition
    transition(':enter', [
      // styles at start of transition
      style({
        opacity: 0,
        // transform: 'scaleY(0)',
      }),

      // animation and styles at end of transition
      animate(
        '0.5s ease-in-out',
        style({
          opacity: 1,
          // transform: 'scaleY(1)',
        }),
      ),
    ]),

    // route 'leave' transition
    transition(':leave', [
      style({
        opacity: 1,
        // transform: 'scaleY(1)',
      }),
      // animation and styles at end of transition
      animate(
        '0.5s ease-in-out',
        style({
          opacity: 0,
          // transform: 'scaleY(0)',
        }),
      ),
    ]),
  ])

export const detailExpandAnimations = trigger('detailExpand', [
  state(
    'collapsed, void',
    style({ height: '0px', minHeight: '0', overflow: 'hidden' }),
  ),
  state('expanded', style({ height: '*' })),
  transition(
    'expanded => collapsed',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0px' })),
  ),
  transition(
    'collapsed => expanded',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '*' })),
  ),
  transition(
    'expanded => void',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '0px' })),
  ),
  transition(
    'void => expanded',
    animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)', style({ height: '*' })),
  ),
])

export const routeFadeAnimations = trigger('routeFadeAnimations', [
  transition('* <=> *', [
    // Set a default  style for enter and leave
    query(
      ':enter, :leave',
      [
        style({
          position: 'absolute',
          left: 0,
          width: '100%',
          opacity: 0,
          // transform: 'scale(0) translateY(100%)',
        }),
      ],
      { optional: true },
    ),
    // Animate the new page in
    query(
      ':enter',
      [
        animate(
          '600ms ease',
          style({
            opacity: 1,
            // transform: 'scale(1) translateY(0)'
          }),
        ),
      ],
      { optional: true },
    ),
  ]),
])

export const inFromRightOutToLeftAnimation = trigger('inFromRightOutToLeft', [
  transition(':enter', [
    style({ transform: 'translateX(100%)' }),
    animate('500ms ease-out', style({ transform: 'translateX(0%)' })),
  ]),
  transition(':leave', [
    animate('500ms ease-out', style({ transform: 'translateX(-100%)' })),
  ]),
])

export const editConfirmSaveAnimation = trigger('editConfirmSaveAnimation', [
  transition('init => confirm, confirm => saving, saving => init', [
    style({ height: '!' }),
    query(':enter', style({ transform: 'translateX(100%)' }), {
      optional: true,
    }),
    query(
      ':enter, :leave',
      style({ position: 'absolute', top: 0, left: 0, right: 0 }),
      { optional: true },
    ),
    // animate the leave page away
    group([
      query(
        ':leave',
        [
          animate(
            '0.3s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(-100%)' }),
          ),
        ],
        { optional: true },
      ),
      // and now reveal the enter
      query(
        ':enter',
        animate(
          '0.3s cubic-bezier(.35,0,.25,1)',
          style({ transform: 'translateX(0)' }),
        ),
        { optional: true },
      ),
    ]),
  ]),
  transition('saving => confirm, confirm => init', [
    style({ height: '!' }),
    query(':enter', style({ transform: 'translateX(-100%)' }), {
      optional: true,
    }),
    query(
      ':enter, :leave',
      style({ position: 'absolute', top: 0, left: 0, right: 0 }),
      { optional: true },
    ),
    // animate the leave page away
    group([
      query(
        ':leave',
        [
          animate(
            '0.3s cubic-bezier(.35,0,.25,1)',
            style({ transform: 'translateX(100%)' }),
          ),
        ],
        { optional: true },
      ),
      // and now reveal the enter
      query(
        ':enter',
        animate(
          '0.3s cubic-bezier(.35,0,.25,1)',
          style({ transform: 'translateX(0)' }),
        ),
        { optional: true },
      ),
    ]),
  ]),
])
